import React, { Fragment, useState } from "react";
import Header from "./Header";
import { Box, Grid } from "@mui/material";
import SideNav from "./SideNav";
import { Outlet } from "react-router-dom";
import { Menu } from "@mui/icons-material";
import Colors from "../Assets/Styles/Colors";
import { onMessageListener } from "../firebase/firebase";

export const Layout = ({ children }) => {
  const [toggleStatus, setToggleStatus] = useState(true)

  const toggleStatusFunc = () => {
    setToggleStatus(!toggleStatus)
  }

  onMessageListener().then(payload => console.log("payload ===>", payload));

  return (
    <Fragment>
      {/* ========== Header ========== */}

      <Header onClick={toggleStatusFunc} status={toggleStatus} />

      <Box
        component={"main"}
        sx={{
          display: "flex",
          minHeight: "100vh",
          transition: 'width 0.5s ease-in-out !important',
        }}
      >
        {/* ========== SideNav ========== */}

        <SideNav onClick={toggleStatusFunc} status={toggleStatus} />

        <Box
          sx={{
            mt: "100px",
            mb: 2,
            mx: 2,
            flexGrow: 1,
            height: "100%",
            width: "calc(100vw - 338px)"
          }}
        >
          {/* {children} */}
          <Grid container>
            <Grid item md={12}>
              <Outlet />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Fragment>
  );
};
